<template>
  <div>
    <v-container fluid v-if="!EditdialogUser && !AddVector">
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('Documents_title') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="5">
              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      :label="'Document Name'"
                      v-model="searchVectorDBName"
                      @keydown.enter="Search"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      Search
                    </v-btn>
                  </v-col>
                </v-row>              
              </v-card> -->
              <div class="page-title">{{ 'Message Document' }}</div>
            </v-col>
            <v-col cols="12" md="7" class="d-flex flex-wrap justify-end gap-2">
              <v-text-field v-model="searchVectorDBName" placeholder="Search" variant="outlined" density="comfortable" class="custom-search-field" hide-details>
                <template v-slot:prepend-inner>
                  <v-icon color="#001763" size="25">mdi-magnify</v-icon>
                </template>
              </v-text-field>

              <v-btn v-if="permissions.add" variant="elevated" class="custom-document-btn" @click="Add()">
                <v-icon size="23" class="mr-2">mdi-plus</v-icon>
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>

              <v-btn color="#4B2869" variant="elevated" class="filter-btn" icon @click="toggleFilterDrawer">
                <v-icon color="white" size="25">mdi-filter-variant</v-icon>
              </v-btn>

              <!-- <div class="action-controls">
                Refresh Button
                <v-btn
                  color="grey-darken-1"
                  class="control-btn refresh-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  @click="ReFreshGet()"
                  icon
                >
                  <v-icon size="24">mdi-refresh</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Refresh
                  </v-tooltip>
                </v-btn>

                Divider
                <v-divider
                  vertical
                  thickness="1"
                  length="50"
                  class="mx-4"
                ></v-divider>

                Add Button
                <v-btn
                  id="button-create-uploadCSV"
                  color="primary"
                  class="control-btn create-btn"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-plus-circle"
                  rounded="xl"
                  @click="Add()"
                >
                  <span class="btn-text">{{ $t("add") }}</span>
                </v-btn>
              </div> -->
            </v-col>
          </v-row>
        </v-card-text>
        <div class="ma-4">
          <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="filteredDataTable"
          :headers="headers"
          :loading="loadingTable"
        >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.number }}</td>
                <td style="text-align: left; padding-left: 16px">{{ item.vectorDBName }}</td>
                <td>
                  <v-menu location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn id="icon-iconmenu-uploadCSV" icon variant="text" density="comfortable" v-bind="props">
                        <v-icon size="22">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissions.add" id="list-duplicate-uploadCSV" @click="popupDuplicate(item.vectorDBName)">
                        <v-list-item-title>{{ $t('vector_management_duplicate') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="permissions.edit" id="list-replace-uploadCSV" @click="popupReplace(item.vectorDBName)">
                        <v-list-item-title>{{ $t('vector_management_replace') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item id="list-version-history-uploadCSV" @click="Version(item.vectorDBName)">
                        <v-list-item-title>{{ $t('gpt_model_management_version_history') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
                <td style="text-align: left">{{ item.createBy }}</td>
                <td style="text-align: left">{{ formatEffectiveDate(item.createDate) || '-'}}</td>
                <td style="text-align: left">{{ formatEffectiveDate(item.lastUpdate) || '-'}}</td>
                <td style="text-align: center; padding: 8px 0">
                  <div class="personal-info-switch-container">
                    <v-switch v-model="item.personalInformation" color="warning" density="compact" hide-details inset :disabled="!permissions.edit" @change="UpdatePersonalInformation(item)" class="personal-switch">
                      <template v-slot:prepend>
                        <v-tooltip location="top" text="Toggle Personal Information Detection">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" :color="item.personalInformation ? 'warning' : 'grey'" class="personal-icon">
                              {{ item.personalInformation ? 'mdi-shield-account' : 'mdi-shield-off-outline' }}
                            </v-icon>
                          </template>
                        </v-tooltip>
                      </template>
                    </v-switch>
                  </div>
                </td>
                <td style="text-align: center; padding: 12px">
                  <!-- Process Status with compact design -->
                  <div class="d-flex justify-center">
                    <div class="status-container">
                      <v-chip :color="getProcessStatusColor(item)" variant="flat" size="small" class="status-chip">
                        <v-icon start size="14">
                          {{ getProcessStatusIcon(item) }}
                        </v-icon>
                        <span class="status-text">{{ item.inProcess }}/{{ item.inProcessMax }}</span>
                      </v-chip>
                    </div>
                  </div>
                </td>
                <td style="text-align: center; padding: 12px">
                  <!-- Minimal reprocess button -->
                  <v-btn
                    id="button-reprocess-uploadCSV"
                    color="orange-lighten-1"
                    variant="flat"
                    size="small"
                    :disabled="!permissions.edit || (item.inProcess >= item.inProcessMax && !item.isError)"
                    @click="Reprocess(item)"
                    class="minimal-btn"
                    icon
                  >
                    <v-img :src="reprocessSVG" alt="Edit Icon" height="22" width="22" />
                    <v-tooltip activator="parent" location="top"> Reprocess document </v-tooltip>
                  </v-btn>
                </td>
                <td style="text-align: left">
                  <div class="effective-date-cell">
                    <template v-if="item.effectiveStartDate || item.effectiveEndDate">
                      <div v-if="item.effectiveStartDate" class="date-row">
                        <span class="date-label">start date</span>
                        <span class="date-value">{{ formatEffectiveDate(item.effectiveStartDate) }}</span>
                      </div>
                      <div v-if="item.effectiveEndDate" class="date-row">
                        <span class="date-label">end date</span>
                        <span class="date-value">{{ formatEffectiveDate(item.effectiveEndDate) }}</span>
                      </div>
                    </template>
                    <span v-else>-</span>
                  </div>
                </td>
                <td style="text-align: center">
                  <span v-if="item.knowledgeCategory !== null" class="category-text">{{ getKnowledgeCategoryText(item.knowledgeCategory) }}</span>
                  <span v-else>{{ '' }}</span>
                </td>
                <td style="text-align: left">
                  <div class="metadata-cell">
                    <div class="metadata-row">
                      <span class="metadata-label">Title</span>
                      <span class="metadata-value">{{ item.title || '-' }}</span>
                    </div>
                    <div class="metadata-row">
                      <span class="metadata-label">Sub-Title</span>
                      <span class="metadata-value">{{ item.subTitle || '-' }}</span>
                    </div>
                    <div class="metadata-row">
                      <span class="metadata-label">Lap</span>
                      <span class="metadata-value">{{ item.chunkOverlapChars != null ? item.chunkOverlapChars : '-' }}</span>
                    </div>
                  </div>
                </td>
                <td style="text-align: center; padding: 8px">
                  <v-switch
                    :model-value="!!(item.activeStatus === true || item.activeStatus === 'true' || item.activeStatus === 1)"
                    @update:model-value="toggleActive(item, $event)"
                    size="small"
                    density="compact"
                    inset
                    hide-details
                    :disabled="!permissions.edit"
                    class="toggle-switch"
                    :class="item.activeStatus === true || item.activeStatus === 'true' || item.activeStatus === 1 ? 'on' : 'off'"
                  ></v-switch>
                </td>
                <td style="text-align: center; padding: 12px">
                  <!-- Minimal action buttons -->
                  <div class="action-container">
                    <div class="action-group" style="justify-content: center">
                      <div style="width: 35px; height: 35px; cursor: pointer" @click="Edit(item)">
                        <v-img v-if="permissions.edit" :src="editImgAction" alt="Edit Icon" height="30" width="30" aspect-ratio="1" />
                        <v-icon v-else color="primary" size="28">mdi-eye-outline</v-icon>
                      </div>

                      <div style="width: 35px; height: 35px; cursor: pointer">
                        <v-img :src="downloadIcon" alt="Download Icon" height="30" width="30" aspect-ratio="1" @click="DownloadCSV(item)" />
                      </div>

                      <div v-if="permissions.delete" class="trash-icon-wrapper" :class="{ 'is-disabled': btnDisableDelete(item) }">
                        <v-icon
                          @click="btnDisableDelete(item) ? null : DeleteByName(item.vectorDBName)"
                          :style="{ cursor: btnDisableDelete(item) ? 'not-allowed' : 'pointer' }"
                          :color="btnDisableDelete(item) ? 'grey-lighten-1' : 'red'"
                          size="30"
                        >mdi-trash-can-outline</v-icon>
                        <v-tooltip v-if="btnDisableDelete(item)" activator="parent" location="top">You can only delete items you created</v-tooltip>
                      </div>
                    </div>
                    <!-- <div class="action-group">
                    Edit
                    <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable" @click="Edit(item)"
                      class="action-btn edit-btn" icon>
                      <v-icon size="18" color="#007BFF">mdi-pencil-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip>
                    </v-btn>

                    <!-- Download -->
                    <!-- <v-btn
                      id="button-download-uploadCSV"
                      variant="text"
                      density="comfortable"
                      @click="DownloadCSV(item)"
                      :disabled="item.inProcess != item.inProcessMax || !item.isError"
                      class="action-btn download-btn"
                      icon
                    >
                      <v-icon size="18">mdi-download-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Download
                      </v-tooltip>
                    </v-btn>
                    <div class="action-divider"></div> -->


                    <!-- Delete -->
                    <!-- <v-btn
                      id="button-delete-uploadCSV"
                      variant="text"
                      density="comfortable"
                      @click="DeleteByName(item.vectorDBName)"
                      class="action-btn delete-btn"
                      icon
                      :disabled="item.inProcess != item.inProcessMax || !item.isError || btnDisableDelete(item)"
                      >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn> -->
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </div>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog_duplicate" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t('vector_duplicate') }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field id="input-vectordbName-uploadCSV" @keypress="handleKeypress" label="vectordbName*" v-model="newvectordbName" :rules="[rules.required]" required outlined></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_duplicate = false">{{ $t('close') }}</v-btn>
          <v-btn v-if="permissions.add" id="button-save-vectordbName-uploadCSV" color="blue darken-1" text @click="SaveDuplicateVector">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_replace" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t('gpt_model_management_replace') }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    id="input-replacevectorname-uploadCSV"
                    :label="'Vector*'"
                    :rules="[rules.required]"
                    :items="filterlistDDLVector"
                    item-text="id"
                    item-title="name"
                    v-model="replacevectorname"
                    clearable
                    outlined
                    required
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_replace = false">{{ $t('close') }}</v-btn>
          <v-btn v-if="permissions.edit" id="button-save-replacevector-uploadCSV" color="blue darken-1" text @click="SaveReplaceVector">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_version" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t('gpt_model_management_version_history') }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table-server
              id="table-popup-versionhistory-uploadCSV"
              v-model:options="options_version"
              :items-per-page="itemsPerPage_version"
              :items-length="searchTotalTable_version"
              :items="menus_version"
              :headers="headers_version_history"
              :footer-props="{ 'items-per-page-options': [5] }"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">{{ item.version }}</td>
                  <td style="text-align: center">{{ item.createDate }}</td>
                  <td style="text-align: center">
                    <v-menu location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn id="button-menu-versionhistory-uploadCSV" icon v-bind="props" variant="text">
                          <v-icon size="22">mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="permissions.edit" id="button-menu-restore-uploadCSV" :key="item.id" @click="changeRestoreNewVersion(item.id, item.vectordbName)">
                          <v-list-item-title>Restore</v-list-item-title>
                        </v-list-item>
                        <v-list-item id="button-menu-view-uploadCSV" @click="view(item.vectordbName, item.id)">
                          <v-list-item-title>View</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: center">{{ item.createBy }}</td>
                </tr>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_version = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog view vector version-->
    <v-dialog v-model="dialog_view" width="80vw">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t('gpt_model_management_version_history_detail') }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table-server
              v-model:options="options3"
              :items-per-page="itemsPerPage2"
              :items-length="searchTotalTable_view_model"
              :items="view_model"
              :headers="headers2"
              :loading="loadingTable"
              loading-text="Loading..."
              fixed-header
              mobile-breakpoint="300"
              class="elevation-1 responsive-table"
            >
              <template v-slot:item.textORG="{ item }">
                <div class="text-container wrap-text">
                  {{ item.textORG }}
                </div>
              </template>
              <template v-slot:item.textEN="{ item }">
                <div class="text-container wrap-text">
                  {{ item.textEN }}
                </div>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" text @click="dialog_view = false">{{ $t('close') }}</v-btn> -->
          <v-btn color="blue darken-1" text @click="closeViewModel()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading Please Wait... -->
    <!-- <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Filter Navigation Drawer - Full Page Overlay -->
    <v-navigation-drawer v-model="filterDrawer" location="right" temporary scrim width="400" class="filter-drawer-fullpage">
      <v-card flat height="100%" class="filter-drawer-card">
        <!-- Header with Icon, Text and Close Button -->
        <v-card-title class="d-flex align-center justify-space-between px-4 py-2">
          <div class="d-flex align-center">
            <img :src="drawerIcon" alt="Filter" class="drawer-icon mr-2" />
            <span class="text-h7 font-weight-bold">Filter</span>
          </div>
          <div class="d-flex align-center gap-2">
            <v-btn variant="text" size="small" @click="clearFilters" class="text-caption"> Clear All </v-btn>
            <v-btn icon variant="text" @click="filterDrawer = false" size="small">
              <v-icon size="24" color="#903F98">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <hr style="border: none; border-top: 1px solid #ededed" class="mx-4" />

        <v-card-text class="pa-4">
          <!-- Status Section -->
          <div class="mb-1">
            <h4 class="filter-section-title">Status</h4>
            <v-checkbox v-model="statusFilters.all" label="All" density="compact" hide-details class="mb-1 custom-checkbox" :color="statusFilters.all ? '#76237E' : '#C9C9C9'"></v-checkbox>
            <v-checkbox v-model="statusFilters.active" label="Active" density="compact" hide-details class="mb-1 custom-checkbox" :color="statusFilters.active ? '#76237E' : '#C9C9C9'"></v-checkbox>
            <v-checkbox
              v-model="statusFilters.inactive"
              label="Inactive"
              density="compact"
              hide-details
              class="mb-1 custom-checkbox"
              :color="statusFilters.inactive ? '#76237E' : '#C9C9C9'"
            ></v-checkbox>
          </div>

          <hr style="border: none; border-top: 1px solid #ededed" class="my-4" />

          <!-- Knowledge Category Section -->
          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Knowledge Category</h4>
            <v-select
              v-model="selectedCategory"
              :items="knowledgeCategories"
              item-title="name"
              item-value="value"
              placeholder="Select Category"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              :menu-props="{
                attach: false,
                zIndex: 9999,
                maxHeight: '200px',
                offsetY: true,
              }"
              class="custom-category-dropdown"
            >
            </v-select>
          </div>
          <hr style="border: none; border-top: 1px solid #ededed" class="my-6" />
          <!-- Effective Start Date Section -->
          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Effective Start Date</h4>
            <VueDatePicker
              v-model="effectiveStartDate"
              placeholder="Start date"
              :enable-time-picker="true"
              :format="'dd/MM/yyyy HH:mm'"
              text-input
              auto-apply
              :max-date="effectiveEndDate"
              :teleport="true"
              class="custom-datetime-picker"
            />
          </div>

          <!-- Effective End Date Section -->
          <div class="mb-4">
            <h4 class="filter-section-title mb-3">Effective End Date</h4>
            <VueDatePicker
              v-model="effectiveEndDate"
              placeholder="End date"
              :enable-time-picker="true"
              :format="'dd/MM/yyyy HH:mm'"
              text-input
              auto-apply
              :min-date="effectiveStartDate"
              :teleport="true"
              class="custom-datetime-picker"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import FilterIcon from '@/assets/images/mage_filter.svg';
import EditIcon from '@/assets/images/edit-icon-new.svg';
import DownloadSvg from '@/assets/images/new_download_icon.svg';
import ReprocessIcon from '@/assets/images/reprocess_new_icon.svg';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: "UploadCSV",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  mixins: [checkPermissionTwo],
  components: {
    VueDatePicker,
  },
  data: () => ({
    knowledgeCategories: [
      { id: 'all', name: 'All Categories', value: null },
      { id: 'promotion', name: 'Promotion', value: 1 },
      { id: 'banking_service', name: 'Banking Service', value: 2 },
      { id: 'product_insurance', name: 'Product Insurance', value: 3 },
      { id: 'customer_support', name: 'Customer Support', value: 4 },
      { id: 'investment_advisory', name: 'Investment Advisory', value: 5 },
    ],
    searchDebounceTimer: null, // Timer for debouncing search input
    filterTimeout: null, // Timer for debouncing filter changes
    reprocessSVG: ReprocessIcon,
    downloadIcon: DownloadSvg,
    editImgAction: EditIcon,
    drawerIcon: FilterIcon,
    filterDrawer: false, // Filter drawer data
    statusFilters: {
      all: true,
      active: false,
      inactive: false,
    },
    selectedCategory: null,
    effectiveStartDate: null,
    effectiveEndDate: null,

    // Add original data storage for frontend filtering
    originalDataTable: [], // Store original unfiltered data
    //........

    uploadDialog: false,
    checkbox1: false,
    EditdialogUser: false,
    AddVector: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchVectorDBName: null,
    searchVectorProcess: 0,
    searchVectorDBName2: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: true,
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    options3: { page: 1, itemsPerPage: 10, sortBy: [null], sortDesc: [null] },
    DDModel: [],
    files: [],
    dataTable: [],
    dataTable2: [],
    isSearch: false,
    isSearch2: false,
    isFirst: true,
    isFirst2: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    searchTotalTable2: 0,
    totalTable2: 0,
    itemsPerPage2: 10,
    showTable: false,
    rules: {
      required: (value) => !!value || 'Required.',
    },
    sortBy: [],
    sortDesc: [],
    dialog_duplicate: false,
    dialog_replace: false,
    listDDLVector: [],
    filterlistDDLVector: [],
    duplicatevectorname: null,
    replacevectorname: null,
    newvectordbName: null,
    selectvectordbname: null,

    vesionvectordbname: null,
    options_version: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dialog_version: false,
    itemsPerPage_version: 5,
    menus_version: [],
    menus_modelid_version: 0,
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    //dialogview
    view_model: [],
    dialog_view: false,
    searchTotalTable_view_model: 0,
    totalTable_view_model: 0,
    headers_version_history: [],
    headers2: [],
  }),
  computed: {
    headers() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false },
        {
          title: 'Document Name',
          value: 'vectordbname',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '200px',
        },
        { title: ' ', value: ' ', align: 'left', sortable: false, width: '60px' },
        {
          title: 'Create by',
          value: 'create_by',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '140px',
        },
        {
          title: 'Create date',
          value: 'create_date',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '140px',
        },
        {
          title: 'Last update',
          value: 'last_update',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '140px',
        },
        { title: 'Personal Info', align: 'center', sortable: false, width: 'auto', minWidth: '130px' },
        { title: 'Process', align: 'center', sortable: false, width: 'auto', minWidth: '110px' },
        { title: 'Reprocess', align: 'center', sortable: false, width: 'auto', minWidth: '110px' },
        {
          title: 'Effective Date',
          value: 'effectiveDate',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '180px',
        },
        {
          title: 'Knowledge Category',
          value: 'knowledgeCategory',
          align: 'left',
          sortable: true,
          width: 'auto',
          minWidth: '180px',
        },
        {
          title: 'Metadata',
          value: 'metadata',
          align: 'left',
          sortable: false,
          width: 'auto',
          minWidth: '200px',
        },
        {
          title: 'Active',
          value: 'active',
          align: 'center',
          sortable: false,
          width: '80px',
        },
        { title: 'Action', align: 'center', sortable: false, width: '150px' },
      ];
    },

    // Computed property for filtered data
    filteredDataTable() {
      let filtered = [...this.originalDataTable];

      // Apply search filter first
      if (this.searchVectorDBName && this.searchVectorDBName.trim()) {
        const searchTerm = this.searchVectorDBName.toLowerCase().trim();
        filtered = filtered.filter((item) => item.vectorDBName && item.vectorDBName.toLowerCase().includes(searchTerm));
      }

      // Apply status filter
      if (this.statusFilters.active) {
        filtered = filtered.filter((item) => {
          // Handle different data types for activeStatus
          return item.activeStatus === true || item.activeStatus === 'true' || item.activeStatus === 1;
        });
      } else if (this.statusFilters.inactive) {
        filtered = filtered.filter((item) => {
          // Handle different data types for activeStatus
          return item.activeStatus === false || item.activeStatus === 'false' || item.activeStatus === 0 || item.activeStatus === null || item.activeStatus === undefined;
        });
      }
      // If 'all' is selected, don't apply status filter

      // Apply knowledge category filter
      if (this.selectedCategory !== null && this.selectedCategory !== undefined) {
        filtered = filtered.filter((item) => item.knowledgeCategory === this.selectedCategory);
      }

      // Apply date filter with OR logic
      if (this.effectiveStartDate || this.effectiveEndDate) {
        filtered = filtered.filter((item) => {
          let matchesDateFilter = false;

          // Check start date condition: item start date >= filter start date
          if (this.effectiveStartDate && item.effectiveStartDate) {
            const itemStartDate = new Date(item.effectiveStartDate);
            const filterStartDate = new Date(this.effectiveStartDate);
            if (itemStartDate >= filterStartDate) {
              matchesDateFilter = true;
            }
          }

          // Check end date condition: item end date <= filter end date
          if (this.effectiveEndDate && item.effectiveEndDate) {
            const itemEndDate = new Date(item.effectiveEndDate);
            const filterEndDate = new Date(this.effectiveEndDate);
            if (itemEndDate <= filterEndDate) {
              matchesDateFilter = true;
            }
          }

          // If only one filter is set, check that condition
          if (this.effectiveStartDate && !this.effectiveEndDate && item.effectiveStartDate) {
            const itemStartDate = new Date(item.effectiveStartDate);
            const filterStartDate = new Date(this.effectiveStartDate);
            matchesDateFilter = itemStartDate >= filterStartDate;
          }

          if (this.effectiveEndDate && !this.effectiveStartDate && item.effectiveEndDate) {
            const itemEndDate = new Date(item.effectiveEndDate);
            const filterEndDate = new Date(this.effectiveEndDate);
            matchesDateFilter = itemEndDate <= filterEndDate;
          }

          return matchesDateFilter;
        });
      }

      const startNumber = ((this.options.page || 1) - 1) * (this.options.itemsPerPage || 10) + 1;
      filtered = filtered.map((item, index) => ({
        ...item,
        number: startNumber + index,
      }));

      console.log('Filtered Data:', filtered);
      return filtered;
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('VectorManagement');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('VectorManagement'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('VectorManagement'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('VectorManagement'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('VectorManagement'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('VectorManagement'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('VectorManagement'),
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    options_version: {
      handler() {
        this.Version(this.vesionvectordbname);
      },
      deep: true,
    },
    options3: {
      handler() {
        this.view(this.vesionvectordbname, this.vectorID);
      },
      deep: true,
    },
    dialog_view(newVal) {
      if (newVal) {
        // เมื่อปิด dialog ให้รีเซ็ต page ๝ละ view_model
        this.options3.page = 1;
        this.view_model = [];
      }
    },
    searchVectorDBName: {
      handler(newValue) {
        // No need to call API, filteredDataTable computed property will handle it
        this.Get(newValue);
        //console.log('Search changed:', newValue);
      },
    },

    // Filter watchers to bind with table data
    'statusFilters.all': {
      handler(newValue) {
        if (newValue) {
          this.statusFilters.active = false;
          this.statusFilters.inactive = false;
        }
        // console.log('Status filter changed - All:', newValue);
        // No API call needed, computed property handles filtering
      },
    },

    'statusFilters.active': {
      handler(newValue) {
        if (newValue) {
          this.statusFilters.all = false;
          this.statusFilters.inactive = false;
        }
        //console.log('Status filter changed - Active:', newValue);
        // No API call needed, computed property handles filtering
      },
    },

    'statusFilters.inactive': {
      handler(newValue) {
        if (newValue) {
          this.statusFilters.all = false;
          this.statusFilters.active = false;
        }
        //console.log('Status filter changed - Inactive:', newValue);
        // No API call needed, computed property handles filtering
      },
    },

    selectedCategory: {
      handler(newCategory) {
        //console.log('Knowledge Category changed:', newCategory);
        // No API call needed, computed property handles filtering
      },
    },

    effectiveStartDate: {
      handler(newStartDate) {
        //console.log('Effective Start Date changed:', newStartDate);
        // With OR logic, date range validation is more flexible
        // Users can set either or both dates for filtering
      },
    },

    effectiveEndDate: {
      handler(newEndDate) {
        //console.log('Effective End Date changed:', newEndDate);
        // With OR logic, date range validation is more flexible
        // Users can set either or both dates for filtering
      },
    },
  },
  methods: {
    // Clear all filters - frontend only
    clearFilters() {
      this.statusFilters = {
        all: true,
        active: false,
        inactive: false,
      };
      this.selectedCategory = null;
      this.effectiveStartDate = null;
      this.effectiveEndDate = null;
      this.searchVectorDBName = null;
    },

    toggleActive(item, isActive) {
      let self = this;

      // Immediately update UI for better user experience
      const previousStatus = item.activeStatus;
      item.activeStatus = isActive;

      // Also update in original data table immediately
      const originalItem = self.originalDataTable.find((orig) => orig.vectorDBName === item.vectorDBName);
      if (originalItem) {
        originalItem.activeStatus = isActive;
      }

      // Show loading state
      self.dialog = true;

      // Prepare API request data
      var parameter = {
        vectorDBName: item.vectorDBName,
        activeStatus: isActive,
      };

      // Call API to update active status
      self.$call.UpdateActiveStatus(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // Show success message
            self.$swal.fire({
              icon: 'success',
              title: 'Status Updated',
              text: `Document ${isActive ? 'activated' : 'deactivated'} successfully`,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            // Revert the changes on API error
            item.activeStatus = previousStatus;
            if (originalItem) {
              originalItem.activeStatus = previousStatus;
            }

            self.$swal.fire({
              icon: 'error',
              title: 'Update Failed',
              text: dataResponse.message || 'Failed to update status',
              timer: 2000,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          // Revert the changes on error
          item.activeStatus = previousStatus;
          if (originalItem) {
            originalItem.activeStatus = previousStatus;
          }

          self.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update status. Please try again.',
            timer: 2000,
          });

          self.dialog = false;
          console.error('UpdateActiveStatus error:', errorResource);
        }
      );
    },
    formatText(text) {
      // ๝ปลงช่องว่างเป็น &nbsp; เพื่อให้รัฝษาช่องว่างได้
      return text.replace(/ /g, '&nbsp;');
    },
    toggleFilterDrawer() {
      this.filterDrawer = !this.filterDrawer;
    },
    Get() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchVectorDBName && self.searchVectorDBName.trim() ? self.searchVectorDBName : null,
        sortDesc: sortOrder,
        sortBy: sortField,
      };

      //console.log('API call without filters:', temp);

      self.$call.GetVectorDBName(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            // Store original data for filtering
            self.originalDataTable = dataResponse.data.data.map((item, index) => ({
              ...item,
              number: index + 1,
            }));
            self.dataTable = [...self.originalDataTable]; // Keep for compatibility
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            if (!self.isFirst) {
              self.AutoRefresh();
            }
          } else {
            self.originalDataTable = [];
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      let { itemsPerPage } = self.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchVectorDBName,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetVectorDBName(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            if (!self.isFirst) {
              //console.log(self.isFirst);
              self.AutoRefresh();
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      let self = this;
      self.loading = true;
      let { page, itemsPerPage } = this.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchVectorDBName,
      };
      self.$call.GetVectorDBName(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      // Search is now handled by computed property filteredDataTable
      // No API call needed, just trigger reactivity
      //console.log('Search triggered for:', this.searchVectorDBName);
    },
    Save() {
      let self = this;
      if (!self.requestVector.modelType || !self.searchVectorDBName2 || !self.requestVector.entity) {
        alert('Please Fill All The Fields!');
        return;
      }
      self.requestVector.vectordbName = self.searchVectorDBName2;
      self.dialog = true;
      try {
        self.$call.UploadCSV2Vector(
          self.requestVector,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.Clear();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    Reprocess(source) {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('vectorReprocess'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            try {
              let data = {
                vectordbName: source.vectorDBName,
              };
              self.$call.ReProcessedVector(
                data,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    source.isError = false;
                    self.Get();
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource.message);
                }
              );
            } catch (error) {
              self.LogTrace(error, 'ReProcess');
            }
          }
        });
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      let temp = csv.replaceAll('\r', '');
      let lines = temp.split('\n');
      if (lines[0] != 'text_org,text_en') {
        this.requestVector.entity = null;
        alert('Please Enter Correct Format!');
      } else {
        const formDataDoc = new FormData();
        formDataDoc.append('entity', files[0]);
        this.requestVector.entity = formDataDoc;
      }
    },
    UpdatePersonalInformation(item) {
      let self = this;
      self.dialog = true;
      var parameter = {
        VectorDBName: item.vectorDBName,
      };
      self.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.Get();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    DeleteByName(name) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionDocumentName'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteVectorDBNameByName(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                    self.GetDDLVector();
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Add() {
      let self = this;
      self.$router.push({
        name: 'UploadVector',
        query: {
          name: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: 'UploadVector',
        query: {
          name: item.vectorDBName,
        },
      });
    },

    DownloadCSV(item) {
      let self = this;
      self.dialog = true;
      // self.$call.GetVectorCSVExport(
      self.$call.GetVectorExcelExport(
        item.vectorDBName,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            let fileName = `${item.vectorDBName}_${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },

    Clear() {
      let self = this;

      self.EditdialogUser = false;
      self.AddVector = false;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.modelType = null;
      self.requestVector.vectordbName = null;

      self.searchVectorDBName = null;
      self.searchVectorDBName2 = null;
      self.dataTable = [];
      self.originalDataTable = []; // Clear original data too
      self.dataTable2 = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;
      self.searchTotalTable2 = 0;
      self.totalTable2 = 0;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    download() {
      const data = [];
      data.push('text_org,text_en\n');
      data.push('ชื่อบทความ (วรรณคดี): พระอภัยมณี,\n');
      data.push('Article Title (Literature): Phra Abhayamani,\n');
      data.push('Article Title (Literature): Phra Abhayamani (พระอภัยมณี),');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_vector.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        for (let value of self.dataTable) {
          if (value.inProcess < value.inProcessMax && !value.isError) {
            self.ReFreshGet();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != '/VectorManagement') {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },

    GetDDLVector() {
      let self = this;
      self.$call.GetDDLVector(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDLVector = dataResponse.data;
          } else {
            self.listDDLVector = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    popupDuplicate(vectorDBName) {
      let self = this;
      self.dialog_duplicate = true;
      self.newvectordbName = null;
      self.duplicatevectorname = vectorDBName;
    },
    SaveDuplicateVector() {
      let self = this;
      if (self.newvectordbName == null || self.newvectordbName == '' || self.duplicatevectorname == null) {
        alert('Please Fill All The Fields!');
        return;
      }
      self.dialog = true;
      let req = {
        vectordbname: self.duplicatevectorname,
        newvectordbname: self.newvectordbName.trim(),
      };
      try {
        self.$call.SaveDuplicateVector(
          req,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.newvectordbName = null;
              self.Get();
              self.GetDDLVector();
            } else {
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
            self.dialog_duplicate = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.dialog_duplicate = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'SaveDuplicateVector');
      }
    },

    popupReplace(vectorDBName) {
      let self = this;
      self.dialog_replace = true;
      self.selectvectordbname = vectorDBName;
      self.filterlistDDLVector = self.listDDLVector.filter((o) => o.name != vectorDBName);
    },
    SaveReplaceVector() {
      let self = this;
      if (self.replacevectorname == null) {
        alert('Please Fill All The Fields!');
        return;
      }
      self.dialog = true;
      let req = {
        selectvectordbname: self.selectvectordbname,
        replacevectordbname: self.replacevectorname,
      };
      try {
        self.$call.SaveReplaceVector(
          req,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.Get();
              self.GetDDLVector();
            }
            self.dialog = false;
            self.dialog_replace = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.dialog_replace = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'SaveReplaceVector');
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      // ฝำหนด Regular Expression สำหรับตรวจสอบตัวอัฝษรไทย, อังฝฤษ, ๝ละตัวเลข
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (!validCharactersRegex.test(String.fromCharCode(charCode))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async Version(vectordbName) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.vesionvectordbName = vectordbName;

      if (self.dialog_version == false) {
        this.options_version.page = 1;
      }

      self.dialog_version = true;
      // self.menus_modelid_version = modelId;
      // self.menus_modeliddisplay_version = modelIDGroup;

      const { page } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: 5,
        vectordbName: vectordbName,
      };

      self.$call.GetTableVectorVersion(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.menus_version = dataResponse.data.data;
            self.searchTotalTable_version = dataResponse.data.total;
            self.totalTable_version = dataResponse.data.total;
          } else {
            self.menus_version = [];
            self.searchTotalTable_version = 0;
            self.totalTable_version = 0;
          }
          self.dialog = false;
          // self.isSearch = false;
          // self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    changeRestoreNewVersion(id, vectordbName) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      let req = {
        ID: id,
        vectordbName: vectordbName,
      };
      self.$call.SaveReStoreVector(
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.Get();
          }
          self.dialog_version = false;
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    view(vectordbName, id) {
      let self = this;
      self.dialog_view = true;
      self.dialog = true;
      let { page, itemsPerPage } = self.options3;
      self.sortBy = self.options3.sortBy == undefined || self.options3.sortBy.length == 0 ? null : self.options3.sortBy[0];
      self.sortDesc = self.options3.sortDesc == undefined || self.options3.sortDesc.length == 0 ? null : self.options3.sortDesc[0];
      self.vesionvectordbname = vectordbName;
      self.vectorID = id;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : null,
        name: vectordbName,
        id: id,
        text_org: null,
        sortDesc: self.sortDesc,
        sortBy: self.sortBy,
      };
      self.$call.ReFreshViewVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.view_model = dataResponse.data.table.data;
            self.searchTotalTable_view_model = dataResponse.data.table.total;
            self.totalTable_view_model = dataResponse.data.table.total;
          } else {
            self.view_model = [];
            self.searchTotalTable_view_model = 0;
            self.totalTable_view_model = 0;
          }
          self.isSearch = false;
          // self.loadingTable = false;
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.dialog_view = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    closeViewModel() {
      let self = this;
      self.dialog_view = false;
    },
    getProcessStatusColor(item) {
      if (item.inProcess === item.inProcessMax) return 'success';
      if (item.inProcess > 0) return 'warning';
      return 'grey';
    },

    getProcessStatusIcon(item) {
      if (item.inProcess === item.inProcessMax) return 'mdi-check-circle';
      if (item.inProcess > 0) return 'mdi-clock-outline';
      return 'mdi-circle-outline';
    },
    UpdatePersonalInformation(item) {
      let self = this;
      self.dialog = true;
      var parameter = {
        VectorDBName: item.vectorDBName,
      };
      self.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.Get();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    formatDate(date) {
      if (!date) return null;
      // Format date to YYYY-MM-DD format
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatEffectiveDate(dateString) {
      if (!dateString) return null;

      try {
        // Convert UTC datetime back to local timezone for display
        // This ensures you see the time you originally saved (e.g., 7:30 PM)
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';

        // Display in local timezone
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (error) {
        console.error('Error formatting effective date:', error);
        return '-';
      }
    },
    formatEffectiveTime(dateString) {
      if (!dateString) return null;

      try {
        // Convert UTC datetime back to local timezone for display
        // This ensures you see the time you originally saved (e.g., 19:30:00)
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';

        // Display in local timezone with 24-hour format
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('Error formatting effective time:', error);
        return '-';
      }
    },
    getKnowledgeCategoryText(category) {
      if (category === null || category === undefined) return null;

      const categoryItem = this.knowledgeCategories.find((item) => item.value === category);
      return categoryItem ? categoryItem.name : category.toString();
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    }
  },

  mounted() {
    let self = this;
    self.GetDate();
    self.GetDDLVector();
    self.headers_version_history = [
      { title: 'Version', align: 'center', sortable: false, width: '95px' },
      { title: 'Modified', align: 'center', sortable: false },
      { title: ' ', align: 'center', sortable: false },
      { title: 'Modified By', align: 'center', sortable: false },
    ];
    //dialog view
    self.headers2 = [
      {
        title: this.$t('no'),
        value: 'number',
        align: 'center',
        justify: 'center',
        sortable: false,
        width: '100px',
        class: 'wrap-text',
      },
      {
        title: 'text_org',
        value: 'textORG',
        align: 'center',
        sortable: true,
        width: '100px',
        class: 'wrap-text',
      },
      {
        title: 'text_en',
        value: 'textEN',
        align: 'center',
        sortable: true,
        width: '100px',
        class: 'wrap-text',
      },
    ];
  },
  beforeDestroy() {
    // No need for debounce timers since filtering is handled in frontend
  },
};
</script>
<style scoped>
.effective-date-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date-row {
  display: flex;
  flex-direction: column;
}

.date-label {
  font-size: 11px;
  color: #666;
  text-transform: lowercase;
}

.date-value {
  font-size: 13px;
}

.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Minimal Status Badge */
.status-badge {
  position: relative;
}

/* Minimal Reprocess Button */
.minimal-btn {
  border-radius: 50% !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.minimal-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.minimal-btn:disabled {
  opacity: 0.4;
  transform: none !important;
  box-shadow: none !important;
}

/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
}

.action-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}

/* Table improvements */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}
.action-group {
  background: none;
  display: flex;
  align-items: center;
  gap: 14px;
}

/* Responsive design */
@media (max-width: 768px) {
  .action-group {
    flex-direction: column;
    gap: 2px;
    padding: 2px;
  }

  .action-btn {
    width: 32px;
    height: 32px;
  }
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.action-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 200px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.refresh-btn {
  margin-left: 9px;
  opacity: 0.7;
}

.refresh-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
  }

  .control-btn {
    flex: 1;
    margin: 0 2px;
  }

  .status-chip {
    min-width: 70px;
    font-size: 0.7rem;
  }

  .status-text {
    font-size: 0.7rem;
  }
}

.status-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-chip {
  font-weight: 500 !important;
  border-radius: 8px !important;
  min-width: 80px;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.status-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.status-text {
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 4px;
}

/* Status Colors */
.status-chip.v-chip--variant-flat.text-success {
  background: rgba(76, 175, 80, 0.1) !important;
  color: #388e3c !important;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.status-chip.v-chip--variant-flat.text-warning {
  background: rgba(255, 152, 0, 0.1) !important;
  color: #f57c00 !important;
  border: 1px solid rgba(255, 152, 0, 0.2);
}

.status-chip.v-chip--variant-flat.text-grey {
  background: rgba(158, 158, 158, 0.1) !important;
  color: #616161 !important;
  border: 1px solid rgba(158, 158, 158, 0.2);
}

/* Icon styling */
.status-chip .v-icon {
  opacity: 0.8;
}

.personal-info-switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 36px;
}

.personal-switch {
  margin: 0 !important;
}

.personal-switch :deep(.v-switch__track) {
  opacity: 0.6;
}

.personal-switch :deep(.v-switch__thumb) {
  transition: all 0.2s ease;
}

.personal-icon {
  transition: all 0.3s ease;
  opacity: 0.7;
}

.personal-switch :deep(.v-input--error) {
  color: inherit !important;
}

/* Hover effects */
.personal-switch:hover .personal-icon {
  opacity: 1;
  transform: scale(1.1);
}

/* Page Title Styling */
.page-title {
  font-weight: 600;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.87);
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 48px;
}

/* New Component Styles */
.filter-btn {
  height: 48px;
  border-radius: 50% !important;
  box-shadow: 0 2px 4px rgba(75, 40, 105, 0.3);
  transition: all 0.2s ease;
}

.filter-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(75, 40, 105, 0.4);
}

.filter-drawer {
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.1);
}

.filter-drawer .v-card-title {
  background: rgba(0, 0, 0, 0.02);
  font-weight: 600;
}

/* Custom Search Field Styling */
.custom-search-field {
  height: 48px !important;
}

.custom-search-field :deep(.v-field) {
  border-radius: 16px 16px !important;
  height: 48px !important;
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__outline__start),
.custom-search-field :deep(.v-field__outline__end) {
  border-color: #c9c9c9 !important;
}

.custom-search-field :deep(.v-field__input) {
  display: flex !important;
  align-items: center !important;
  min-height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.custom-search-field :deep(.v-field__prepend-inner) {
  display: flex !important;
  align-items: center !important;
  padding-left: 5px !important;
}

.custom-search-field :deep(.v-input__control) {
  height: 48px !important;
}

.custom-search-field :deep(.v-field__field) {
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
}

/* Custom Document Button Styling */
.custom-document-btn {
  color: #ffff;
  text-transform: none;
  box-shadow: 0 2px 4px rgba(80, 72, 151, 0.3);
  border-radius: 16px !important;
  height: 48px !important;
  min-width: 170px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
}

.custom-document-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(80, 72, 151, 0.4);
}

.database-text {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  padding-bottom: 4px;
}

/* Filter Drawer Full Page Overlay */
.filter-drawer-fullpage {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  z-index: 1999 !important;
  border-radius: 16px 0 0 16px;
}
.filter-drawer-card {
  border-radius: 16px 0 0 16px;
}

.v-navigation-drawer__scrim {
  background-color: rgba(0, 0, 0, 0.9) !important;
  z-index: 1997 !important;
}

/* Filter Drawer Styling */
.drawer-icon {
  width: 24px;
  height: 24px;
}

.filter-section-title {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}

/* Custom Checkbox Styling */
.custom-checkbox {
  font-size: 14px;
}

.custom-checkbox :deep(.v-selection-control__wrapper) {
  color: inherit;
}

/* Custom Category Dropdown Styling */
.custom-category-dropdown {
  margin-bottom: 8px !important;
}

.custom-category-dropdown :deep(.v-field) {
  border-radius: 48px !important;
  border: 1px solid #c9c9c9 !important;
  background: white !important;
  transition: all 0.2s ease !important;
}

.custom-category-dropdown :deep(.v-field__outline) {
  display: none !important;
}

.custom-category-dropdown :deep(.v-field__input) {
  padding: 12px 16px !important;
  min-height: 48px !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.custom-category-dropdown:hover :deep(.v-field) {
  border-color: #903f98 !important;
}

.custom-category-dropdown :deep(.v-field--focused) {
  border-color: #903f98 !important;
  box-shadow: 0 0 0 2px rgba(144, 63, 152, 0.1) !important;
}
.date-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  white-space: nowrap;
}

.category-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.04);
}

/* Action Button Color Updates */
.action-btn {
  transition: all 0.2s ease;
  border-radius: 8px;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  transform: scale(1.1);
}

.edit-btn:hover {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

.download-btn:hover {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

.delete-btn:hover {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

/* Disabled trash icon — visually convey it can't be clicked */
.trash-icon-wrapper.is-disabled {
  opacity: 0.5;
  pointer-events: auto;
}

.trash-icon-wrapper.is-disabled .v-icon {
  cursor: not-allowed !important;
}

/* Table Row Improvements */
:deep(.v-data-table tbody tr) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

::v-deep.v-switch--inset .v-switch__thumb {
  height: 26px !important;
  width: 28px !important;
  transform: none !important;
}

/* Custom inset switch styling */
::v-deep.toggle-switch.v-switch--inset .v-switch__track {
  width: 55px !important;
  height: 30px !important;
  background-color: #c2c2c2 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  border: none !important;
  border-radius: 50px !important;
  min-width: none;
}
::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__thumb {
  background-color: #4e3982 !important;
}
::v-deep.toggle-switch.v-switch--inset .v-selection-control--dirty .v-switch__track {
  background-color: #ffffff !important;
  border: 1px solid #4e3982 !important;
}
.time-text {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}
.custom-rounded-table {
  border: 1px solid #f5f5f5 !important;
  border-radius: 16px !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th {
  background: #f5f5f5 !important;
  font-weight: 600 !important;
  color: #000000 !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th:first-child {
  border-top-left-radius: 16px !important;
}
::v-deep .v-table .v-table__wrapper > table > thead > tr > th:last-child {
  border-top-right-radius: 16px !important;
}

.filter-drawer-fullpage {
  z-index: 8000 !important;
}

.card2 {
  overflow: visible !important;
}

.filter-drawer-card {
  overflow: visible !important;
}

.download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Metadata cell styles */
.metadata-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
}

.metadata-row {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.metadata-label {
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.metadata-value {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
}


</style>
